// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlist-moduleTOC-body-2{font-size:.875rem!important;letter-spacing:.0178571429em!important;line-height:1.25rem}", ""]);
// Exports
module.exports = exports;
